import styled from 'styled-components';
import { getFontStyle } from '~components/Text/helper';

export const ChartWrapper = styled.div``;

export const PieWrapper = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  text-align: center;
  margin: 0 auto;
`;

export const EmptyChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 280px;
  height: 160px;
  position: relative;
  margin: 0 auto;
`;

export const DummyPieChart = styled.div`
  width: 120px;
  height: 120px;
  margin: 0 auto 20px;
  background: ${({ theme }) => theme.colors.gray200};
  border-radius: 50%;

  ${({ theme }) => theme.media.mobile} {
    margin-bottom: 0;
  }
`;

export const NoData = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  text-align: center;
  color: ${({ theme }) => theme.colors.gray600};
  ${getFontStyle('midium150_B3')};

  ${({ theme }) => theme.media.mobile} {
    top: 90px;
    transform: translate3d(-50%, 0, 0);
  }
`;
